<template><div><code-example only-show="demo">
<dt-stack gap="200">
  <dt-stack direction="row" gap="200" justify="space-between" class="d-w100p">
    <dt-text as="h4" kind="headline" :size="400">Demo</dt-text>
    <dt-dropdown
      navigation-type="arrow-keys"
      placement="bottom-end"
    >
      <template #anchor>
        <dt-button
          importance="outlined"
          kind="muted"
          :size="200"
        >
          <dt-stack gap="100" direction="row">
            <span>
              <dt-text strength="bold">Mode:</dt-text>
              <dt-text tone="tertiary">{{ currentMode.charAt(0).toUpperCase() + currentMode.slice(1) }}</dt-text>
            </span>
            <span>
              <dt-text strength="bold">Contrast:</dt-text>
              <dt-text tone="tertiary">{{ currentContrast.charAt(0).toUpperCase() + currentContrast.slice(1) }}</dt-text>
            </span>
          </dt-stack>
          <template #startIcon="{ iconSize }">
            <dt-icon
              :size="iconSize"
              :name="currentModeIconName"
            />
          </template>
          <template #endIcon="{ iconSize }">
            <dt-icon
              :size="iconSize"
              name="chevron-down"
            />
          </template>
        </dt-button>
      </template>
      <template #list>
        <dt-list-item-group
          heading-class="d-py-50 d-px-100 d-c-default d-fc-tertiary d-label--sm"
          heading="Mode"
        >
          <dt-list-item
            role="menuitem"
            navigation-type="arrow-keys"
            @click="setMode('system')"
          >
            System
            <template #end>
              <dt-icon :class="{ 'd-o0': currentMode !== 'system' }" name="check" size="200" />
            </template>
          </dt-list-item>
          <dt-list-item
            role="menuitem"
            navigation-type="arrow-keys"
            @click="setMode('light')"
          >
            Light
            <template #end>
              <dt-icon :class="{ 'd-o0': currentMode !== 'light' }" name="check" size="200" />
            </template>
          </dt-list-item>
          <dt-list-item
            role="menuitem"
            navigation-type="arrow-keys"
            @click="setMode('dark')"
          >
            Dark
            <template #end>
              <dt-icon :class="{ 'd-o0': currentMode !== 'dark' }" name="check" size="200" />
            </template>
          </dt-list-item>
        </dt-list-item-group>
        <dt-dropdown-separator />
        <dt-list-item-group
          heading-class="d-py-50 d-px-100 d-c-default d-fc-tertiary d-label--sm"
          heading="Contrast"
        >
          <dt-list-item
            role="menuitem"
            navigation-type="arrow-keys"
            @click="setContrast('default')"
          >
            Default
            <template #end>
              <dt-icon :class="{ 'd-o0': currentContrast !== 'default' }" name="check" size="200" />
            </template>
          </dt-list-item>
          <dt-list-item
            role="menuitem"
            navigation-type="arrow-keys"
            @click="setContrast('high')"
          >
            High
            <template #end>
              <dt-icon :class="{ 'd-o0': currentContrast !== 'high' }" name="check" size="200" />
            </template>
          </dt-list-item>
        </dt-list-item-group>
      </template>
    </dt-dropdown>
  </dt-stack>
  <dt-stack :direction="{ 'default': 'column', 'lg': 'row' }" gap="200" class="d-w100p">
    <dt-stack gap="100" class="d-fl1">
      <dt-text as="h3" kind="headline" :size="300">Inverted <dt-text strength="normal">(auto)</dt-text></dt-text>
      <dt-stack v-dt-mode:invert gap="100" class="d-bgc-secondary d-p-200 d-bar-400 d-ba d-bc-default">
        <dt-stack gap="100" direction="row">
          <dt-icon name="circle-half-filled" size="300" class="d-fc-positive" />
          <dt-text as="p" kind="body" :size="200">Primary</dt-text>
          <dt-text as="p" kind="body" :size="200" tone="muted">Muted</dt-text>
          <dt-text as="p" kind="body" :size="200" tone="critical">Critical</dt-text>
          <dt-link>Link</dt-link>
        </dt-stack>
        <dt-stack direction="row" gap="100" class="d-100p">
          <dt-button :size="200" class="d-fl1">Button</dt-button>
          <dt-button :size="200" class="d-fl1" kind="critical">Button</dt-button>
        </dt-stack>
      </dt-stack>
    </dt-stack>
    <dt-stack gap="100" class="d-fl1">
      <dt-text as="h3" kind="headline" :size="300">Explicit light</dt-text>
      <dt-stack v-dt-mode:light gap="100" class="d-bgc-secondary d-p-200 d-bar-400 d-ba d-bc-default">
        <dt-stack gap="100" direction="row">
          <dt-icon name="sun" size="300" class="d-fc-positive" />
          <dt-text as="p" kind="body" :size="200">Primary</dt-text>
          <dt-text as="p" kind="body" :size="200" tone="muted">Muted</dt-text>
          <dt-text as="p" kind="body" :size="200" tone="critical">Critical</dt-text>
          <dt-link>Link</dt-link>
        </dt-stack>
        <dt-stack direction="row" gap="100" class="d-100p">
          <dt-button :size="200" class="d-fl1">Button</dt-button>
          <dt-button :size="200" class="d-fl1" kind="critical">Button</dt-button>
        </dt-stack>
      </dt-stack>
    </dt-stack>
    <dt-stack gap="100" class="d-fl1">
      <dt-text as="h3" kind="headline" :size="300">Explicit dark</dt-text>
      <dt-stack v-dt-mode:dark gap="100" class="d-bgc-secondary d-p-200 d-bar-400 d-ba d-bc-default">
        <dt-stack gap="100" direction="row">
          <dt-icon name="moon" size="300" class="d-fc-positive" />
          <dt-text as="p" kind="body" :size="200">Primary</dt-text>
          <dt-text as="p" kind="body" :size="200" tone="muted">Muted</dt-text>
          <dt-text as="p" kind="body" :size="200" tone="critical">Critical</dt-text>
          <dt-link>Link</dt-link>
        </dt-stack>
        <dt-stack direction="row" gap="100" class="d-100p">
          <dt-button :size="200" class="d-fl1">Button</dt-button>
          <dt-button :size="200" class="d-fl1" kind="critical">Button</dt-button>
        </dt-stack>
      </dt-stack>
    </dt-stack>
  </dt-stack>
</dt-stack>
</code-example>
<!-- <component-combinator component-name="DtModeIsland" /> -->
<h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Use the <code v-pre>v-dt-mode</code> directive to control the color mode of a region, component, or element. It creates a scoped region with the specified mode. Descendant elements retain their original styling but are rendered with the specified mode.</p>
<code-example source-code='&lt;dt-text v-dt-mode:dark tone=&quot;positive&quot;&gt; Dark content &lt;/dt-text&gt;
&lt;dt-text v-dt-mode:light tone=&quot;positive&quot;&gt; Light content &lt;/dt-text&gt;
&lt;dt-text v-dt-mode:invert tone=&quot;positive&quot;&gt; Inverted — opposite of parent or root &lt;/dt-text&gt;'>
<dt-stack data-demo-wrapper gap="100">
  <dt-text v-dt-mode:dark tone="positive"> Dark content </dt-text>
  <dt-text v-dt-mode:light tone="positive"> Light content </dt-text>
  <dt-text v-dt-mode:invert tone="positive"> Inverted — opposite of parent or root </dt-text>
</dt-stack>
</code-example>
<h3 id="inverting" tabindex="-1" class="d-docsite--header-3">Inverting <a class="header-anchor d-link d-docsite--link d-link" href="#inverting" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">This effectively removes the need for <code v-pre>inverted</code> props or variants on elements or components.</p>
<p class="d-docsite--paragraph">For example, instead of using <code v-pre>inverted</code> on a DtButton, use <code v-pre>v-dt-mode:invert</code></p>
<code-example source-code='&lt;dt-button&gt;Button&lt;/dt-button&gt;
&lt;dt-button v-dt-mode:invert&gt;Button&lt;/dt-button&gt;'>
<dt-stack data-demo-wrapper gap="200" direction="row">
  <dt-button>Button</dt-button>
  <dt-button v-dt-mode:invert>Button</dt-button>
</dt-stack>
</code-example>
<h3 id="dynamic-mode" tabindex="-1" class="d-docsite--header-3">Dynamic mode <a class="header-anchor d-link d-docsite--link d-link" href="#dynamic-mode" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Bind a reactive variable as the directive arg to switch modes at runtime.</p>
<code-example source-code='&lt;dt-text v-dt-mode:{mode} align=&quot;center&quot; tone=&quot;positive&quot;&gt; ... mode &lt;/dt-text&gt;'>
<dt-stack gap="200">
  <dt-segmented-control :size="100" v-model="dynamicMode" aria-label="Mode">
    <dt-segmented-control-item value="invert" :selected="dynamicMode === 'invert'">
      <template #startIcon="{ iconSize }">
        <dt-icon name="circle-half-filled" :size="iconSize" />
      </template>
      Invert
    </dt-segmented-control-item>
    <dt-segmented-control-item value="light" :selected="dynamicMode === 'light'">
      <template #startIcon="{ iconSize }">
        <dt-icon name="sun" :size="iconSize" />
      </template>
      Light
    </dt-segmented-control-item>
    <dt-segmented-control-item value="dark" :selected="dynamicMode === 'dark'">
      <template #startIcon="{ iconSize }">
        <dt-icon name="moon" :size="iconSize" />
      </template>
      Dark
    </dt-segmented-control-item>
  </dt-segmented-control>
  <dt-text v-dt-mode:[dynamicMode] align="center" tone="positive"> {{ dynamicMode }} mode </dt-text>
</dt-stack>
</code-example>
<h3 id="conditional" tabindex="-1" class="d-docsite--header-3">Conditional <a class="header-anchor d-link d-docsite--link d-link" href="#conditional" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Pass a boolean value to conditionally apply or remove the directive. When <code v-pre>false</code>, mode attributes are removed entirely.</p>
<div class="language-vue" data-highlighter="prismjs" data-ext="vue"><pre v-pre><code class="language-vue"><span class="line"><span class="token tag"><span class="token tag"><span class="token punctuation">&lt;</span>dt-button</span> <span class="token attr-name"><span class="token namespace">v-dt-mode:</span>invert</span><span class="token attr-value"><span class="token punctuation attr-equals">=</span><span class="token punctuation">"</span>isInverted<span class="token punctuation">"</span></span><span class="token punctuation">></span></span>Button<span class="token tag"><span class="token tag"><span class="token punctuation">&lt;/</span>dt-button</span><span class="token punctuation">></span></span></span>
<span class="line"></span></code></pre>
</div><h3 id="guidance" tabindex="-1" class="d-docsite--header-3">Guidance <a class="header-anchor d-link d-docsite--link d-link" href="#guidance" aria-hidden="true">#</a></h3>
<dialtone-usage>
<template #do>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">Use sparingly for specific needs, not general theming</li>
<li class="d-docsite--list-element">Use only to force a region to a controlled theme for a unique purpose</li>
<li class="d-docsite--list-element">Always test in both light and dark root themes</li>
<li class="d-docsite--list-element">Ensure content remains readable when mode changes</li>
</ul>
</template>
<template #dont>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">Do not overuse mode islands, respect user theme preference</li>
<li class="d-docsite--list-element">Do not use purely for decoration. Ensure mode island use serves a functional and unique purpose</li>
<li class="d-docsite--list-element">Avoid nesting deeply. Keep hierarchy shallow for maintainability</li>
</ul>
</template>
</dialtone-usage>
<h3 id="how-it-works" tabindex="-1" class="d-docsite--header-3">How it works <a class="header-anchor d-link d-docsite--link d-link" href="#how-it-works" aria-hidden="true">#</a></h3>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">CSS tokens activate via <code v-pre>[data-dt-mode=&quot;light&quot;]</code> and <code v-pre>[data-dt-mode=&quot;dark&quot;]</code> attribute selectors</li>
<li class="d-docsite--list-element">High-contrast tokens layer via <code v-pre>[data-dt-mode][data-dt-contrast=&quot;high&quot;]</code></li>
<li class="d-docsite--list-element">Contrast is inherited from the root <code v-pre>&lt;html&gt;</code> element and kept in sync via MutationObserver</li>
<li class="d-docsite--list-element">For <code v-pre>invert</code> mode, the directive reads the nearest ancestor's <code v-pre>data-dt-mode</code>, computes the opposite, and reacts when it changes</li>
<li class="d-docsite--list-element"><code v-pre>data-dt-brand</code> (theme) cannot be set on mode islands — brand is root-level only</li>
</ul>
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="inverted" tabindex="-1" class="d-docsite--header-3">Inverted <a class="header-anchor d-link d-docsite--link d-link" href="#inverted" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">The default mode — inverts relative to the nearest parent mode boundary or the root. When no arg is provided, <code v-pre>v-dt-mode</code> defaults to invert.</p>
<code-example source-code='&lt;section v-dt-mode class=&quot;d-p-200 d-bar-400&quot;&gt;
  &lt;dt-text as=&quot;p&quot; tone=&quot;positive&quot;&gt;Inverted mode (opposite of parent)&lt;/dt-text&gt;
&lt;/section&gt;'>
<section v-dt-mode class="d-p-200 d-bar-400">
  <dt-text as="p" tone="positive">Inverted mode (opposite of parent)</dt-text>
</section>
</code-example>
<h3 id="light" tabindex="-1" class="d-docsite--header-3">Light <a class="header-anchor d-link d-docsite--link d-link" href="#light" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Explicitly set to light mode regardless of parent or root mode.</p>
<code-example source-code='&lt;section v-dt-mode:light class=&quot;d-p-200 d-bar-400&quot;&gt;
  &lt;dt-text as=&quot;p&quot; tone=&quot;positive&quot;&gt;Always light mode&lt;/dt-text&gt;
&lt;/section&gt;'>
<section v-dt-mode:light class="d-p-200 d-bar-400">
  <dt-text as="p" tone="positive">Always light mode</dt-text>
</section>
</code-example>
<h3 id="dark" tabindex="-1" class="d-docsite--header-3">Dark <a class="header-anchor d-link d-docsite--link d-link" href="#dark" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Explicitly set to dark mode regardless of parent or root mode.</p>
<code-example source-code='&lt;section v-dt-mode:dark class=&quot;d-p-200 d-bar-400&quot;&gt;
  &lt;dt-text as=&quot;p&quot; tone=&quot;positive&quot;&gt;Always dark mode&lt;/dt-text&gt;
&lt;/section&gt;'>
<section v-dt-mode:dark class="d-p-200 d-bar-400">
  <dt-text as="p" tone="positive">Always dark mode</dt-text>
</section>
</code-example>
<h2 id="nesting" tabindex="-1" class="d-docsite--header-2">Nesting <a class="header-anchor d-link d-docsite--link d-link" href="#nesting" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Mode boundaries can be nested. Each <code v-pre>v-dt-mode:invert</code> reads the nearest parent boundary and flips. In this example the first level is explicitly set to light mode, the second level inverts against that, and the third level inverts again.</p>
<code-example source-code='&lt;dt-stack gap=&quot;200&quot; v-dt-mode:light class=&quot;d-p-200 d-bar-400 d-bgc-secondary d-ba&quot;&gt;
  &lt;dt-text as=&quot;p&quot; tone=&quot;positive&quot; text-box-trim=&quot;both&quot;&gt;Explicit Light&lt;/dt-text&gt;
  &lt;dt-stack v-dt-mode gap=&quot;200&quot; class=&quot;d-p-200 d-bar-400 d-bgc-secondary&quot;&gt;
    &lt;dt-text as=&quot;p&quot; tone=&quot;positive&quot; text-box-trim=&quot;both&quot;&gt;Inverted (Dark)&lt;/dt-text&gt;
    &lt;dt-stack v-dt-mode gap=&quot;200&quot; class=&quot;d-p-200 d-bar-300 d-bgc-secondary&quot;&gt;
      &lt;dt-text as=&quot;p&quot; tone=&quot;positive&quot; text-box-trim=&quot;both&quot;&gt;Inverted again (Light)&lt;/dt-text&gt;
    &lt;/dt-stack&gt;
  &lt;/dt-stack&gt;
&lt;/dt-stack&gt;'>
<dt-stack gap="200" v-dt-mode:light class="d-p-200 d-bar-400 d-bgc-secondary d-ba">
  <dt-text as="p" tone="positive" text-box-trim="both">Explicit Light</dt-text>
  <dt-stack v-dt-mode gap="200" class="d-p-200 d-bar-400 d-bgc-secondary">
    <dt-text as="p" tone="positive" text-box-trim="both">Inverted (Dark)</dt-text>
    <dt-stack v-dt-mode gap="200" class="d-p-200 d-bar-300 d-bgc-secondary">
      <dt-text as="p" tone="positive" text-box-trim="both">Inverted again (Light)</dt-text>
    </dt-stack>
  </dt-stack>
</dt-stack>
</code-example>
<h2 id="custom-background" tabindex="-1" class="d-docsite--header-2">Custom background <a class="header-anchor d-link d-docsite--link d-link" href="#custom-background" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">The background surface of a Mode Island defaults to the root surface color. To override, use a CSS Utility class.</p>
<code-example source-code='&lt;dt-mode-island class=&quot;d-p-200 d-bar-400 d-w100p d-bgc-transparent&quot;&gt;
    &lt;dt-stack gap=&quot;200&quot;&gt;
      &lt;dt-text as=&quot;p&quot; kind=&quot;code&quot; :size=&quot;100&quot; tone=&quot;tertiary&quot;&gt;Transparent background, inverted mode island&lt;/dt-text&gt;
      &lt;div&gt;
        &lt;dt-button&gt;Button&lt;/dt-button&gt;
      &lt;/div&gt;
    &lt;/dt-stack&gt;
  &lt;/dt-mode-island&gt;
  &lt;dt-mode-island class=&quot;d-p-200 d-bar-400 d-w100p&quot;&gt;
    &lt;dt-stack gap=&quot;200&quot;&gt;
      &lt;dt-text as=&quot;p&quot; kind=&quot;code&quot; :size=&quot;100&quot; tone=&quot;tertiary&quot;&gt;Default background, inverted mode island&lt;/dt-text&gt;
      &lt;div&gt;
        &lt;dt-button&gt;Button&lt;/dt-button&gt;
      &lt;/div&gt;
    &lt;/dt-stack&gt;
  &lt;/dt-mode-island&gt;
  &lt;dt-mode-island mode=&quot;dark&quot; class=&quot;d-p-200 d-bar-400 d-w100p d-bgc-critical&quot;&gt;
    &lt;dt-stack gap=&quot;200&quot;&gt;
      &lt;dt-text as=&quot;p&quot; kind=&quot;code&quot; :size=&quot;100&quot; tone=&quot;tertiary&quot;&gt;critical background, dark mode island&lt;/dt-text&gt;
      &lt;div&gt;
        &lt;dt-button&gt;Button&lt;/dt-button&gt;
      &lt;/div&gt;
    &lt;/dt-stack&gt;
  &lt;/dt-mode-island&gt;
  &lt;dt-mode-island mode=&quot;light&quot; class=&quot;d-p-200 d-bar-400 d-w100p d-bgc-critical&quot;&gt;
    &lt;dt-stack gap=&quot;200&quot;&gt;
      &lt;dt-text as=&quot;p&quot; kind=&quot;code&quot; :size=&quot;100&quot; tone=&quot;tertiary&quot;&gt;critical background, light mode island&lt;/dt-text&gt;
      &lt;div&gt;
        &lt;dt-button&gt;Button&lt;/dt-button&gt;
      &lt;/div&gt;
    &lt;/dt-stack&gt;
  &lt;/dt-mode-island&gt;'>
<dt-stack data-demo-wrapper gap="200">
  <dt-mode-island class="d-p-200 d-bar-400 d-w100p d-bgc-transparent">
      <dt-stack gap="200">
        <dt-text as="p" kind="code" :size="100" tone="tertiary">Transparent background, inverted mode island</dt-text>
        <div>
          <dt-button>Button</dt-button>
        </div>
      </dt-stack>
    </dt-mode-island>
    <dt-mode-island class="d-p-200 d-bar-400 d-w100p">
      <dt-stack gap="200">
        <dt-text as="p" kind="code" :size="100" tone="tertiary">Default background, inverted mode island</dt-text>
        <div>
          <dt-button>Button</dt-button>
        </div>
      </dt-stack>
    </dt-mode-island>
    <dt-mode-island mode="dark" class="d-p-200 d-bar-400 d-w100p d-bgc-critical">
      <dt-stack gap="200">
        <dt-text as="p" kind="code" :size="100" tone="tertiary">critical background, dark mode island</dt-text>
        <div>
          <dt-button>Button</dt-button>
        </div>
      </dt-stack>
    </dt-mode-island>
    <dt-mode-island mode="light" class="d-p-200 d-bar-400 d-w100p d-bgc-critical">
      <dt-stack gap="200">
        <dt-text as="p" kind="code" :size="100" tone="tertiary">critical background, light mode island</dt-text>
        <div>
          <dt-button>Button</dt-button>
        </div>
      </dt-stack>
    </dt-mode-island>
</dt-stack>
</code-example>
<h2 id="examples" tabindex="-1" class="d-docsite--header-2">Examples <a class="header-anchor d-link d-docsite--link d-link" href="#examples" aria-hidden="true">#</a></h2>
<h3 id="callbar" tabindex="-1" class="d-docsite--header-3">Callbar <a class="header-anchor d-link d-docsite--link d-link" href="#callbar" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">A real-world pattern: the callbar container already exists as a semantic element. The directive applies mode theming directly — no wrapper needed.</p>
<code-example source-code='&lt;dt-stack v-dt-mode class=&quot;d-ba d-bc-subtle d-bgc-secondary d-p-75 d-py-50 d-bar-450 d-bs-md d-w100p&quot; direction=&quot;row&quot; gap=&quot;400&quot;&gt;
  &lt;dt-stack gap=&quot;100&quot; direction=&quot;row&quot;&gt;
    &lt;dt-avatar
      full-name=&quot;TA&quot;
      seed=&quot;ted-anderson&quot;
      :size=&quot;400&quot;
    /&gt;
    &lt;dt-stack gap=&quot;25&quot;&gt;
      &lt;dt-text kind=&quot;label&quot; :size=&quot;300&quot; density=&quot;200&quot;&gt;Ted Anderson&lt;/dt-text&gt;
      &lt;dt-stack direction=&quot;row&quot; gap=&quot;50&quot; align=&quot;baseline&quot;&gt;
        &lt;dt-text kind=&quot;body&quot; :size=&quot;100&quot; tone=&quot;tertiary&quot; wrap=&quot;nowrap&quot; numeric&gt;(913) 555-6745&lt;/dt-text&gt;
        &lt;dt-text kind=&quot;body&quot; :size=&quot;100&quot; tone=&quot;muted&quot;&gt;&amp;bull;&lt;/dt-text&gt;
        &lt;dt-text kind=&quot;body&quot; :size=&quot;100&quot; tone=&quot;tertiary&quot; numeric&gt;21:18&lt;/dt-text&gt;
      &lt;/dt-stack&gt;
    &lt;/dt-stack&gt;
  &lt;/dt-stack&gt;
  &lt;dt-stack class=&quot;d-fl1&quot; direction=&quot;row&quot; gap=&quot;25&quot; justify=&quot;center&quot;&gt;
    &lt;dt-button class=&quot;d-px-100 d-w-100&quot; :size=&quot;100&quot; kind=&quot;critical&quot;&gt;
      &lt;template #blockStartIcon&gt; &lt;dt-icon name=&quot;mic&quot; size=&quot;300&quot; /&gt; &lt;/template&gt;
      Unmute
    &lt;/dt-button&gt;
    &lt;dt-button class=&quot;d-px-100 d-w-100&quot; :size=&quot;100&quot; kind=&quot;muted&quot; importance=&quot;clear&quot;&gt;
      &lt;template #blockStartIcon&gt; &lt;dt-icon name=&quot;record-filled&quot; size=&quot;300&quot; /&gt; &lt;/template&gt;
      Record
    &lt;/dt-button&gt;
    &lt;dt-button class=&quot;d-px-100 d-w-100&quot; :size=&quot;100&quot; kind=&quot;muted&quot; importance=&quot;clear&quot;&gt;
      &lt;template #blockStartIcon&gt; &lt;dt-icon name=&quot;keypad&quot; size=&quot;300&quot; /&gt; &lt;/template&gt;
      Keypad
    &lt;/dt-button&gt;
    &lt;dt-button class=&quot;d-px-100 d-w-100&quot; :size=&quot;100&quot; kind=&quot;muted&quot; importance=&quot;clear&quot;&gt;
      &lt;template #blockStartIcon&gt; &lt;dt-icon name=&quot;user-plus&quot; size=&quot;300&quot; /&gt; &lt;/template&gt;
      Add
    &lt;/dt-button&gt;
    &lt;dt-button class=&quot;d-px-100 d-w-100&quot; :size=&quot;100&quot; kind=&quot;muted&quot; importance=&quot;clear&quot;&gt;
      &lt;template #blockStartIcon&gt; &lt;dt-icon name=&quot;more-horizontal&quot; size=&quot;300&quot; /&gt; &lt;/template&gt;
      More
    &lt;/dt-button&gt;
  &lt;/dt-stack&gt;
  &lt;dt-stack&gt;
    &lt;dt-button class=&quot;d-p-150&quot; circle :size=&quot;400&quot; kind=&quot;critical&quot;&gt;
      &lt;template #startIcon&gt; &lt;dt-icon name=&quot;phone-hang-up&quot; size=&quot;500&quot; /&gt; &lt;/template&gt;
    &lt;/dt-button&gt;
  &lt;/dt-stack&gt;
&lt;/dt-stack&gt;
&lt;dt-text as=&quot;p&quot; kind=&quot;label&quot; :size=&quot;200&quot; tone=&quot;muted&quot; class=&quot;d-mbs-100&quot;&gt;* Not real, still just an example&lt;/dt-text&gt;'>
<dt-stack v-dt-mode class="d-ba d-bc-subtle d-bgc-secondary d-p-75 d-py-50 d-bar-450 d-bs-md d-w100p" direction="row" gap="400">
  <dt-stack gap="100" direction="row">
    <dt-avatar
      full-name="TA"
      seed="ted-anderson"
      :size="400"
    />
    <dt-stack gap="25">
      <dt-text kind="label" :size="300" density="200">Ted Anderson</dt-text>
      <dt-stack direction="row" gap="50" align="baseline">
        <dt-text kind="body" :size="100" tone="tertiary" wrap="nowrap" numeric>(913) 555-6745</dt-text>
        <dt-text kind="body" :size="100" tone="muted">&bull;</dt-text>
        <dt-text kind="body" :size="100" tone="tertiary" numeric>21:18</dt-text>
      </dt-stack>
    </dt-stack>
  </dt-stack>
  <dt-stack class="d-fl1" direction="row" gap="25" justify="center">
    <dt-button class="d-px-100 d-w-100" :size="100" kind="critical">
      <template #blockStartIcon> <dt-icon name="mic" size="300" /> </template>
      Unmute
    </dt-button>
    <dt-button class="d-px-100 d-w-100" :size="100" kind="muted" importance="clear">
      <template #blockStartIcon> <dt-icon name="record-filled" size="300" /> </template>
      Record
    </dt-button>
    <dt-button class="d-px-100 d-w-100" :size="100" kind="muted" importance="clear">
      <template #blockStartIcon> <dt-icon name="keypad" size="300" /> </template>
      Keypad
    </dt-button>
    <dt-button class="d-px-100 d-w-100" :size="100" kind="muted" importance="clear">
      <template #blockStartIcon> <dt-icon name="user-plus" size="300" /> </template>
      Add
    </dt-button>
    <dt-button class="d-px-100 d-w-100" :size="100" kind="muted" importance="clear">
      <template #blockStartIcon> <dt-icon name="more-horizontal" size="300" /> </template>
      More
    </dt-button>
  </dt-stack>
  <dt-stack>
    <dt-button class="d-p-150" circle :size="400" kind="critical">
      <template #startIcon> <dt-icon name="phone-hang-up" size="500" /> </template>
    </dt-button>
  </dt-stack>
</dt-stack>
<dt-text as="p" kind="label" :size="200" tone="muted" class="d-mbs-100">* Not real, still just an example</dt-text>
</code-example>
<h3 id="positioned-components" tabindex="-1" class="d-docsite--header-3">Positioned Components <a class="header-anchor d-link d-docsite--link d-link" href="#positioned-components" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph"><a href="/components/popover.html" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Popovers</a>, <a href="/components/dropdown.html" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Dropdowns</a>, <a href="/components/modal.html" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Modals</a>, and <a href="/components/hovercard.html" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Hovercards</a> render their content <em>outside</em> the normal DOM tree, so <code v-pre>v-dt-mode</code> on the component itself won't reach the positioned element. These components provide a <code v-pre>contentMode</code> prop that applies the mode directly to the positioned content.</p>
<code-example source-code='&lt;!-- Hovercard --&gt;
&lt;dt-hovercard placement=&quot;top-start&quot; content-mode=&quot;invert&quot;&gt;
  &lt;template #anchor&gt;
    &lt;dt-button :size=&quot;200&quot; kind=&quot;muted&quot; importance=&quot;outlined&quot;&gt;Default&lt;/dt-button&gt;
  &lt;/template&gt;
  &lt;template #content&gt;
    &lt;ExampleProfileCard /&gt;
  &lt;/template&gt;
&lt;/dt-hovercard&gt;
&lt;!-- Popover --&gt;
&lt;dt-popover content-mode=&quot;invert&quot; placement=&quot;top-start&quot; dialogClass=&quot;d-w-350&quot;&gt;
  &lt;template #anchor&gt;
    &lt;dt-button :size=&quot;200&quot; kind=&quot;muted&quot; importance=&quot;outlined&quot;&gt; Inverted &lt;/dt-button&gt;
  &lt;/template&gt;
  &lt;template #content=&quot;{ close }&quot;&gt;
    &lt;dt-text as=&quot;p&quot;&gt;This Popover content is in the &lt;dt-text strength=&quot;strong&quot;&gt;inverted&lt;/dt-text&gt; mode.&lt;/dt-text&gt;
  &lt;/template&gt;
&lt;/dt-popover&gt;
&lt;!-- Dropdown --&gt;
&lt;dt-dropdown content-mode=&quot;invert&quot; navigation-type=&quot;arrow-keys&quot; placement=&quot;bottom-start&quot;&gt;
  &lt;template #anchor=&quot;{ attrs }&quot;&gt;
    &lt;dt-button v-bind=&quot;attrs&quot; :size=&quot;200&quot; kind=&quot;muted&quot; importance=&quot;outlined&quot;&gt;
      Inverted
      &lt;template #endIcon=&quot;{ iconSize }&quot;&gt;
        &lt;dt-icon name=&quot;chevron-down&quot; :size=&quot;iconSize&quot; /&gt;
      &lt;/template&gt;
    &lt;/dt-button&gt;
  &lt;/template&gt;
  &lt;template #list=&quot;{ close }&quot;&gt;
    &lt;dt-list-item
      v-for=&quot;item in items&quot;
      :key=&quot;item.id&quot;
      role=&quot;menuitem&quot;
      :navigation-type=&quot;arrow - keys&quot;
      @click=&quot;close&quot;
    &gt;
      {{ item.name }}
    &lt;/dt-list-item&gt;
  &lt;/template&gt;
&lt;/dt-dropdown&gt;'>
<dt-stack gap="200">
  <dt-stack gap="25">
    <dt-text as="p" kind="headline" :size="300">Hovercard</dt-text>
    <dt-stack gap="100" direction="row">
      <dt-hovercard placement="top-start">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined">Default </dt-button>
        </template>
        <template #content>
          <ExampleProfileCard />
        </template>
      </dt-hovercard>
      <dt-hovercard content-mode="invert" placement="top-start">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined">Inverted </dt-button>
        </template>
        <template #content>
          <ExampleProfileCard />
        </template>
      </dt-hovercard>
      <dt-hovercard content-mode="light" placement="top-start">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined">Light </dt-button>
        </template>
        <template #content>
          <ExampleProfileCard />
        </template>
      </dt-hovercard>
      <dt-hovercard content-mode="dark" placement="top-start">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined">Dark </dt-button>
        </template>
        <template #content>
          <ExampleProfileCard />
        </template>
      </dt-hovercard>
    </dt-stack>
  </dt-stack>
  <dt-stack gap="25">
    <dt-text as="p" kind="headline" :size="300">Popover</dt-text>
    <dt-stack gap="100" direction="row">
      <dt-popover placement="top-start" dialogClass="d-w-350">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined"> Default </dt-button>
        </template>
        <template #content="{ close }">
          <dt-text as="p">This is just a default Popover, and does not use Mode Island.</dt-text>
        </template>
      </dt-popover>
      <dt-popover content-mode="invert" placement="top-start" dialogClass="d-w-350">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined"> Inverted </dt-button>
        </template>
        <template #content="{ close }">
          <dt-text as="p">This Popover's content is in the <dt-text strength="strong">inverted</dt-text> mode.</dt-text>
        </template>
      </dt-popover>
      <dt-popover content-mode="light" placement="top-start" dialogClass="d-w-350">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined"> Light </dt-button>
        </template>
        <template #content="{ close }">
          <dt-text as="p">This Popover's content is in explicit <dt-text strength="strong">light</dt-text> mode.</dt-text>
        </template>
      </dt-popover>
      <dt-popover content-mode="dark" placement="top-start" dialogClass="d-w-350">
        <template #anchor>
          <dt-button :size="200" kind="muted" importance="outlined"> Dark </dt-button>
        </template>
        <template #content="{ close }">
          <dt-text as="p">This Popover's content is in explicit <dt-text strength="strong">dark</dt-text> mode.</dt-text>
        </template>
      </dt-popover>
    </dt-stack>
  </dt-stack>
  <dt-stack gap="25">
    <dt-text as="p" kind="headline" :size="300">Dropdown</dt-text>
    <dt-stack gap="100" direction="row">
      <dt-dropdown navigation-type="arrow-keys" placement="bottom-start">
        <template #anchor="{ attrs }">
          <dt-button v-bind="attrs" :size="200" kind="muted" importance="outlined">
            Default
            <template #endIcon="{ iconSize }">
              <dt-icon name="chevron-down" :size="iconSize" />
            </template>
          </dt-button>
        </template>
        <template #list="{ close }">
          <dt-list-item
            v-for="item in items"
            :key="item.id"
            role="menuitem"
            :navigation-type="arrow - keys"
            @click="close"
          >
            {{ item.name }}
          </dt-list-item>
        </template>
      </dt-dropdown>
      <dt-dropdown content-mode="invert" navigation-type="arrow-keys" placement="bottom-start">
        <template #anchor="{ attrs }">
          <dt-button v-bind="attrs" :size="200" kind="muted" importance="outlined">
            Inverted
            <template #endIcon="{ iconSize }">
              <dt-icon name="chevron-down" :size="iconSize" />
            </template>
          </dt-button>
        </template>
        <template #list="{ close }">
          <dt-list-item
            v-for="item in items"
            :key="item.id"
            role="menuitem"
            :navigation-type="arrow - keys"
            @click="close"
          >
            {{ item.name }}
          </dt-list-item>
        </template>
      </dt-dropdown>
      <dt-dropdown content-mode="light" navigation-type="arrow-keys" placement="bottom-start">
        <template #anchor="{ attrs }">
          <dt-button v-bind="attrs" :size="200" kind="muted" importance="outlined">
            Light
            <template #endIcon="{ iconSize }">
              <dt-icon name="chevron-down" :size="iconSize" />
            </template>
          </dt-button>
        </template>
        <template #list="{ close }">
          <dt-list-item
            v-for="item in items"
            :key="item.id"
            role="menuitem"
            :navigation-type="arrow - keys"
            @click="close"
          >
            {{ item.name }}
          </dt-list-item>
        </template>
      </dt-dropdown>
      <dt-dropdown content-mode="dark" navigation-type="arrow-keys" placement="bottom-start">
        <template #anchor="{ attrs }">
          <dt-button v-bind="attrs" :size="200" kind="muted" importance="outlined">
            Dark
            <template #endIcon="{ iconSize }">
              <dt-icon name="chevron-down" :size="iconSize" />
            </template>
          </dt-button>
        </template>
        <template #list="{ close }">
          <dt-list-item
            v-for="item in items"
            :key="item.id"
            role="menuitem"
            :navigation-type="arrow - keys"
            @click="close"
          >
            {{ item.name }}
          </dt-list-item>
        </template>
      </dt-dropdown>
    </dt-stack>
  </dt-stack>
</dt-stack>
</code-example>
<h2 id="component" tabindex="-1" class="d-docsite--header-2">Component <a class="header-anchor d-link d-docsite--link d-link" href="#component" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">The <code v-pre>&lt;dt-mode-island&gt;</code> component is the underlying abstraction that the directive builds on. The key rendered difference is that it creates a wrapper element, while the directive attaches to mode to the existing element.</p>
<dt-notice kind="info" title="Note" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
The only real case where you might want to use the component is when you need to create a container element that doesn't already exist, but even then, you can create any kind of containing element with the directive e.g. <code v-pre>&lt;span v-dt-mode:invert&quot;&gt;...&lt;/span&gt;</code>.
</dt-notice>
<code-example only-show="code" source-code='&lt;dt-mode-island as=&quot;section&quot;&gt;
  Rendered as a section element inverted
&lt;/dt-mode-island&gt;
&lt;dt-mode-island&gt;
  Inverted (default)
&lt;/dt-mode-island&gt;
&lt;dt-mode-island mode=&quot;light&quot;&gt;
  Light
&lt;/dt-mode-island&gt;
&lt;dt-mode-island mode=&quot;dark&quot;&gt;
  Dark
&lt;/dt-mode-island&gt;'>
<dt-mode-island as="section">
  Rendered as a section element inverted
</dt-mode-island>
<dt-mode-island>
  Inverted (default)
</dt-mode-island>
<dt-mode-island mode="light">
  Light
</dt-mode-island>
<dt-mode-island mode="dark">
  Dark
</dt-mode-island>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<h3 id="directive" tabindex="-1" class="d-docsite--header-3">Directive <a class="header-anchor d-link d-docsite--link d-link" href="#directive" aria-hidden="true">#</a></h3>
<div class="language-javascript" data-highlighter="prismjs" data-ext="js"><pre v-pre><code class="language-javascript"><span class="line"><span class="token keyword">import</span> <span class="token punctuation">{</span> DtModeDirective <span class="token punctuation">}</span> <span class="token keyword">from</span> <span class="token string">'@dialpad/dialtone-vue'</span><span class="token punctuation">;</span></span>
<span class="line">app<span class="token punctuation">.</span><span class="token function">use</span><span class="token punctuation">(</span>DtModeDirective<span class="token punctuation">)</span><span class="token punctuation">;</span></span>
<span class="line"></span></code></pre>
</div><h3 id="component-1" tabindex="-1" class="d-docsite--header-3">Component <a class="header-anchor d-link d-docsite--link d-link" href="#component-1" aria-hidden="true">#</a></h3>
<component-vue-api component-name="modeisland" /><h2 id="accessibility" tabindex="-1" class="d-docsite--header-2">Accessibility <a class="header-anchor d-link d-docsite--link d-link" href="#accessibility" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Purely visual. No semantic HTML impact. Supports high contrast mode via auto contrast inheritance.</p>
</div></template>


<script setup>
import { DtIconPhone, DtIconQuickReply, DtIconVideo } from '@dialpad/dialtone-icons/vue';
import ExampleProfileCard from '@exampleComponents/ExampleProfileCard.vue';
import { useThemeManager } from '@composables/useThemeManager';
import { ref } from 'vue';
// Use theme manager composable without theme switching (mode + contrast only)
const {
  currentMode,
  currentContrast,
  currentModeIconName,
  setMode,
  setContrast,
} = useThemeManager({ includeThemes: false });

const dynamicMode = ref('invert');

const items = ref([
  { id: '1', name: 'Option 1' },
  { id: '2', name: 'Option 2' },
  { id: '3', name: 'Option 3' },
]);

</script>